<div class="backoffice-companies-container">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="start_date">
      <th mat-header-cell *matHeaderCellDef>Fecha de inicio</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormated(element.start_date) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="end_date">
      <th mat-header-cell *matHeaderCellDef>Fecha fin</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormated(element.end_date) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="start_time">
      <th mat-header-cell *matHeaderCellDef>Hora inicio</th>
      <td mat-cell *matCellDef="let element">
        {{ dateToHours(element.start_time) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="end_time">
      <th mat-header-cell *matHeaderCellDef>Hora fin</th>
      <td mat-cell *matCellDef="let element">
        {{ dateToHours(element.end_time) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="private_price">
      <th mat-header-cell *matHeaderCellDef>Precio â¬</th>
      <td mat-cell *matCellDef="let element">{{ element.private_price }}</td>
    </ng-container>
    <ng-container matColumnDef="public_price">
      <th mat-header-cell *matHeaderCellDef>Precio cowings</th>
      <td mat-cell *matCellDef="let element">{{ element.public_price }}</td>
    </ng-container>

    <ng-container matColumnDef="user_id">
      <th mat-header-cell *matHeaderCellDef>ID coworker</th>
      <td mat-cell *matCellDef="let element">{{ element.user_id }}</td>
    </ng-container>
    <ng-container matColumnDef="coworker_email">
      <th mat-header-cell *matHeaderCellDef>Email coworker</th>
      <td mat-cell *matCellDef="let element">{{ element.coworker_email }}</td>
    </ng-container>

    <ng-container matColumnDef="coworking_id">
      <th mat-header-cell *matHeaderCellDef>ID coworking</th>
      <td mat-cell *matCellDef="let element">{{ element.coworking_id }}</td>
    </ng-container>
    <ng-container matColumnDef="coworking_name">
      <th mat-header-cell *matHeaderCellDef>Nombre coworking</th>
      <td mat-cell *matCellDef="let element">{{ element.coworking_name }}</td>
    </ng-container>

    <ng-container matColumnDef="company_id">
      <th mat-header-cell *matHeaderCellDef>ID Empresa</th>
      <td mat-cell *matCellDef="let element">{{ element.company_id }}</td>
    </ng-container>
    <ng-container matColumnDef="company_name">
      <th mat-header-cell *matHeaderCellDef>Nombre empresa</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>
    <ng-container matColumnDef="duration_price_id">
      <th mat-header-cell *matHeaderCellDef>DuraciÃ³n</th>
      <td mat-cell *matCellDef="let element">
        <mat-select
          [(ngModel)]="element.duration_price_id"
          name="duration_price_id"
          (selectionChange)="changeDuration($event, element.id)"
        >
          <mat-option
            *ngFor="let duration of getDurations(element.space_id)"
            [value]="duration.id"
          >
            {{ duration.title }}
          </mat-option>
        </mat-select>
      </td>
    </ng-container>
    <ng-container matColumnDef="state_id">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let element">
        <mat-select
          [(ngModel)]="element.state_id"
          name="state_id"
          (selectionChange)="changeStatus($event, element.id)"
        >
          <mat-option *ngFor="let state of bookingStates" [value]="state.id">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </td>
    </ng-container>
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>Creado</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.created_at) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef>Modificado</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.updated_at) }}
      </td>
    </ng-container>
    <!-- <ng-container matColumnDef="space_id"> -->
    <!-- <th mat-header-cell *matHeaderCellDef>ID Spac</th>
      <td mat-cell *matCellDef="let element">{{ element.space_id }}</td>
    </ng-container> -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <div class="actions">
          <div (click)="editBooking(element)">
            <img [src]="getEditIcon" alt="" />
          </div>
          <div (click)="deleteBooking(element)">
            <img [src]="getDeleteIcon" alt="" />
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="20"></mat-paginator>
</div>
